import Image from 'next/image';

export function Header({ title }) {
  return (
    <header style={{ backgroundColor: 'rgb(81,46,143)' }}>
      <nav className="max-w-4xl mx-auto" aria-label="Top">
        <div className="w-full flex items-center justify-between px-5 lg:px-0">
          <div className="flex items-center">
            <Image src="/Logo WIT.png" width="80px" height="80px" />
          </div>
          <div className="ml-10 space-x-4">
            <div className="flex-1 min-w-0">
              <h1 className="leading-7 text-white text-1xl md:text-2xl rsca-title">
                {title}
              </h1>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
